import { CssBaseline, LinearProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { NoSessionError } from '@/api/NoSessionError';
import Header from '@/components/Header';
import InactivityLogoutTimer from '@/lib/InactivityLogoutTimer';
import { QueryClient, useIsFetching } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAuth } from 'react-oidc-context';



export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
    component: function RootComponent() {
        const isFetching = useIsFetching()

        return (
            <>
                <CssBaseline />
                <Box sx={{ display: 'flex' }}>
                    <Header />
                    <Box
                        component="main"
                        id="main"
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light'
                                    ? theme.palette.grey[100]
                                    : theme.palette.grey[900],
                            flexGrow: 1,
                            p: 1,
                            height: '100vh',
                            paddingTop: '50px',
                            paddingLeft: '2px',
                            paddingRight: '0px',
                            paddingBottom: '0px',
                            overflow: 'auto',
                            // width: { xs: '100%', md: `calc(100% - 240px)` }
                        }}
                    >
                        {isFetching ? <Box sx={{ width: '100%' }}><LinearProgress /></Box> : null}
                        <Outlet />
                    </Box>
                </Box>
                <InactivityLogoutTimer />
                {import.meta.env.VITE_DEBUG === 'true' &&
                    <TanStackRouterDevtools />
                }
            </>
        )
    }
    ,
    errorComponent: function ErrorComponent({ error }) {
        const auth = useAuth()
        if (error instanceof NoSessionError) {
            auth.signinRedirect();
            return <></>
        }
        if (error instanceof AxiosError) {
            const axiosError = error as AxiosError
            if (axiosError.response && axiosError.response.status === 401) {
                auth.signinRedirect();
                return <></>
            }
        }

        return (
            <>
                <CssBaseline />
                <Box sx={{ display: 'flex' }}>
                    <Header />
                    <Box
                        component="main"
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light'
                                    ? theme.palette.grey[100]
                                    : theme.palette.grey[900],
                            flexGrow: 1,
                            p: 1,
                            height: '100vh',
                            paddingTop: '50px',
                            paddingLeft: '2px',
                            paddingRight: '0px',
                            paddingBottom: '0px',
                            overflow: 'auto',
                            width: { xs: '100%', md: `calc(100% - 240px)` }
                        }}
                    >
                        Error: {error.message}
                        <br />
                        <pre><b>{error.name}</b></pre>
                        {import.meta.env.VITE_DEBUG === 'true' &&
                            <pre>{error.stack}</pre>
                        }
                    </Box>
                </Box>
                {import.meta.env.VITE_DEBUG === 'true' &&
                    <TanStackRouterDevtools />
                }
            </>)
    }
})